import React, { useEffect } from 'react';
import PuffLoader  from 'react-spinners/PuffLoader';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { usePresence } from 'framer-motion';

interface BusyProps{
    message: string;
}

const Busy: React.FC<BusyProps>= ({message}) => {  
    
const [, safeToRemove] = usePresence();
const theme = useTheme();
  
useEffect(() => {
    if(safeToRemove) safeToRemove();   
    
  }, [safeToRemove]);

  return (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '500px'
       }}>
        <PuffLoader 
          loading={true}
          color={theme.palette.primary.main}        
        />
        <Typography variant='h5'>{message}</Typography>
      </div>
  );
};

export default Busy;
